export default __webpack_public_path__ + "static/media/image-jussi.3ee90f3b.png";